var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.788 12L6.25 7.463a.857.857 0 1 1 1.212-1.212L12 10.788l4.537-4.537a.857.857 0 0 1 1.212 1.212L13.212 12l4.537 4.537a.857.857 0 0 1-1.212 1.212L12 13.212 7.463 17.75a.857.857 0 1 1-1.212-1.212L10.788 12z","fill":"currentColor"}));
}

Close.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Close;

Close.default = Close;
